import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'end',
  justifyContent: 'space-between',
  // padding: (p) => p.spacing(2),
  // backgroundColor: (p) => p.palette.grey[200],
  // borderRadius: (p) => p.spacing(2),
};

export const boxPlan: SxStyle = {
  flex: '1 1 0%',
  minWidth: 0,
  maxWidth: '100%',
};
